<template>
  <div class="flex flex-row items-center">
    <component
      v-if="icon"
      class="self-center min-h-[12px] min-w-[13px]"
      :class="fill ? `fill-${fill}` : undefined"
      :is="icon" />
    <CircleCheck
      v-else
      class="self-center min-w-[25px] max-w-[25px] min-h-[25px]"
      ring="var(--color-blue-4)" />
    <article class="ml-2.5">
      <h6 v-if="title">{{ title }}</h6>
      <p :class="title ? 'paragraph-1' : 'button-1'">{{ text }}</p>
    </article>
  </div>
</template>

<script setup lang="ts">
import CircleCheck from '@/components/icons/CircleCheck.vue'

type Props = {
  icon?: unknown
  text: string
  fill?: string
  title?: string
}

defineProps<Props>()
</script>
